import { render, staticRenderFns } from "./TimeFrequency.vue?vue&type=template&id=0f3d8812&scoped=true&"
import script from "./TimeFrequency.vue?vue&type=script&lang=js&"
export * from "./TimeFrequency.vue?vue&type=script&lang=js&"
import style0 from "./TimeFrequency.vue?vue&type=style&index=0&id=0f3d8812&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3d8812",
  null
  
)

export default component.exports